/**
 * @generated SignedSource<<e364655d4599c89f82829837ebbb029f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "PROCESSING" | "WAITING";
export type tasksVirtualTryOnTaskStatusQuery$variables = {
  taskId: number;
};
export type tasksVirtualTryOnTaskStatusQuery$data = {
  readonly virtualTryOnTaskStatus: {
    readonly completedAt: string | null;
    readonly createdAt: string;
    readonly errorMessage: string | null;
    readonly processingTimeMs: number | null;
    readonly resultUrl: string | null;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  } | null;
};
export type tasksVirtualTryOnTaskStatusQuery = {
  response: tasksVirtualTryOnTaskStatusQuery$data;
  variables: tasksVirtualTryOnTaskStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskId",
        "variableName": "taskId"
      }
    ],
    "concreteType": "VirtualTryOnTaskStatus",
    "kind": "LinkedField",
    "name": "virtualTryOnTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "processingTimeMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksVirtualTryOnTaskStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tasksVirtualTryOnTaskStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "80f555cba23bd7ca21bcabff8a16c943",
    "id": null,
    "metadata": {},
    "name": "tasksVirtualTryOnTaskStatusQuery",
    "operationKind": "query",
    "text": "query tasksVirtualTryOnTaskStatusQuery(\n  $taskId: Long!\n) {\n  virtualTryOnTaskStatus(taskId: $taskId) {\n    taskId\n    state\n    resultUrl\n    errorMessage\n    processingTimeMs\n    createdAt\n    completedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "d17b326e7806e559cd8651632da794dd";

export default node;
